"use strict";

exports.__esModule = true;
exports["default"] = exports.WysiwygFootnote = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _primitives = _interopRequireDefault(require("../../primitives"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var WysiwygFootnote = function WysiwygFootnote(_ref) {
  var dataTestId = _ref["data-test-id"],
      text = _ref.text;
  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Box, {
    color: "legal-grey",
    "data-test-id": dataTestId,
    mt: 2,
    tag: "footer"
  }, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Text, null, text));
};

exports.WysiwygFootnote = WysiwygFootnote;
WysiwygFootnote.propTypes = {
  /** cypress test id */
  "data-test-id": _propTypes.string,

  /** Footnote text  */
  text: _propTypes.string
};
WysiwygFootnote.displayName = "Modules.WysiwygFootnote";
var _default = WysiwygFootnote;
exports["default"] = _default;